import React, { useState } from 'react';
import SignInSide from '../../templates/loginTemplateSide';
import SignIn from '../../templates/loginTemplate';

export default function (props: any) {
  const [loginTemplate, setTemplate] = useState<'signIn' | 'signInSide'>(
    'signInSide'
  );

  switch (loginTemplate) {
    case 'signInSide':
      return <SignInSide {...props} />;
    default:
      return <SignIn {...props} />;
  }
}
